module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      A. J. Liebling, Fred Warner, James Harbour\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("A.J. Liebling ")]), _vm._v("joined the staff of "), _c('I', [_vm._v("The New Yorker")]), _vm._v(" in 1935 and wrote for the magazine until his death in 1963. His books include "), _c('I', [_vm._v("Between Meals, A Neutral Corner")]), _vm._v(", and "), _c('I', [_vm._v("The Honest Rainmaker.")]), _c('br'), _c('B', [_c('br'), _vm._v("Fred Warner")]), _vm._v(" and "), _c('B', [_vm._v("James Barbour")]), _vm._v(" are emeritus professors at the University of New Mexico.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/6vrVKp/tc-custom/9781466896376.jpg?1732161401288",
      "alt": "This image is the cover for the book Neutral Corner"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Neutral Corner\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("A Neutral Corner")]), _vm._v(" collects fifteen previously unpublished boxing pieces written by legendary sportswriter A.J. Liebling between 1952 and 1963."), _c('br')]), _c('br'), _vm._v("Demonstrating A.J. Liebling's abiding passion for the \"sweet science\" of boxing, "), _c('i', [_vm._v("A Neutral Corner")]), _vm._v(" brings together previously unpublished material. Antic, clear-eyed, and wildly entertaining, these essays showcase a"), _c('i', [_vm._v(" The New Yorker")]), _vm._v(" journalist at the top of his form. Here one relives the high drama of the classic Patterson-Johansson championship bout of 1959, and Liebling's early prescient portrayal of Cassius Clay's style as a boxer and a poet is not to be missed."), _c('br'), _c('br'), _vm._v("Liebling always finds the human story that makes these essays appealing to aficionados of boxing and prose alike. Alive with a true fan's reverence for the sport, yet balanced by a true skeptic's disdain for sentiment, "), _c('i', [_vm._v("A Neutral Corner ")]), _vm._v("is an American treasure.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Farrar, Straus and Giroux\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0